var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.article.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.article.content)}})]):_c('div',[_c('p',[_vm._v("文章加载失败...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }